import {AxiosInstance} from "axios";
import PaymentRecommendation from "../model/payment/PaymentRecommendation";
import Payment from "../model/payment/Payment";

/**
 * Bill payment Api.
 */
export default class BillPaymentApi {
	constructor(public readonly axiosInstance: AxiosInstance) {}

	fetchBillPayments(billId: string): Promise<Array<Payment>> {
		const url = `/api/web/accounting/bills/${billId}/payments`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(Payment.fromJson));
	}

	fetchBillPaymentRecommendations(billId: string): Promise<PaymentRecommendation[]> {
		const url = `/api/web/accounting/bills/${billId}/payment_recommendations`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(PaymentRecommendation.fromJson));
	}

	/**
	 * Confirm payment recommendation.
	 * @param {string} paymentRecommendationId
	 * @returns {Promise<any>}
	 */
	confirmBillPaymentRecommendation(paymentRecommendationId: string): Promise<any> {
		const url = `/api/web/accounting/bills/payment_recommendations/${paymentRecommendationId}/confirm`;
		return this.axiosInstance.put(url);
	}

	/**
	 * Reject payment recommendation.
	 * @param {string} paymentRecommendationId
	 * @returns {AxiosPromise<any>}
	 */
	rejectBillPaymentRecommendation(paymentRecommendationId: string): Promise<any> {
		const url = `/api/web/accounting/bills/payment_recommendations/${paymentRecommendationId}/reject`;
		return this.axiosInstance.put(url);
	}
}
